import React from 'react';
import {Button} from 'react-bootstrap';
import {DefaultModal} from '../../components';
import {ModalsStore, PriceAlertsStore} from '../../stores';
import {ModalsAction, PriceAlertsAction} from '../../actions';
import {extractUnits, convertModalPayload, getAlertLocation, getAlertLocationLabel, formatPercentageChange} from './helpers';

export default class ResolveAlertModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertData: {},
      newValue: '',
      isSubmitting: false,
      error: null
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleModalChange = this.handleModalChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    ModalsStore.addChangeListener(this.handleModalChange);
    PriceAlertsStore.addChangeListener(this.handleStoreChange.bind(this));
  }

  componentWillUnmount() {
    ModalsStore.removeChangeListener(this.handleModalChange);
    PriceAlertsStore.removeChangeListener(this.handleStoreChange.bind(this));
  }

  handleStoreChange() {
    // If modal is still submitting and store updated successfully, close modal
    if (this.state.isSubmitting) {
      this.setState({isSubmitting: false});
      ModalsAction.hide(this.props.id);
    }
  }

  handleModalChange() {
    if (ModalsStore.isModalVisible(this.props.id)) {
      const payload = ModalsStore.getPayload(this.props.id);
      const alertData = convertModalPayload(payload);
      
      this.setState({
        alertData: alertData || {},
        newValue: alertData && alertData.value && alertData.value.value ? alertData.value.value : '',
        error: null
      });
    }
  }

  handleChange(e) {
    this.setState({
      newValue: e.target.value,
      error: null
    });
  }

  handleSave() {
    const {alertData, newValue} = this.state;

    if (!newValue || isNaN(parseFloat(newValue))) {
      this.setState({error: 'Please enter a valid price value'});
      return;
    }

    this.setState({isSubmitting: true});

    PriceAlertsAction.resolveAlert(alertData.id, parseFloat(newValue));
    // Modal will close when store updates via handleStoreChange
  }

  render() {
    const {alertData, newValue, isSubmitting, error} = this.state;
    
    // Loading state
    if (!alertData || Object.keys(alertData).length === 0) {
      return (
        <DefaultModal
          id={this.props.id}
          title={this.props.title}
          onHide={this.props.onHide}
          bsSize="medium">
          <div>Loading...</div>
        </DefaultModal>
      );
    }
    
    const previousValue = alertData.previousValue ? alertData.previousValue.value : 'N/A';
    const prevUnits = extractUnits(alertData.previousValue, alertData);
    const currUnits = extractUnits(alertData.value, alertData);
    const percentage = formatPercentageChange(alertData.percentageChange);

    return (
      <DefaultModal
        id={this.props.id}
        title={this.props.title}
        onHide={this.props.onHide}
        bsSize="medium">
        <div>
          <div className="row">
            <div className="col-md-6">
              <strong>Supplier: </strong>{alertData.Supplier ? alertData.Supplier.name : 'N/A'}
            </div>
            <div className="col-md-6">
              <strong>{getAlertLocationLabel(alertData)} </strong>{getAlertLocation(alertData)}
            </div>
          </div>
          <hr />
          
          <div className="form-group">
            <label className="control-label">Previous Price (Read-only)</label>
            <div className="row">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  value={String(previousValue)}
                  disabled={true}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  value={`${prevUnits.currency}/${prevUnits.volumeUnit}`}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div className={error ? 'form-group has-error' : 'form-group'}>
            <label className="control-label">New Price (Editable)</label>
            <div className="row">
              <div className="col-md-6">
                <input
                  type="number"
                  className="form-control"
                  step="0.01"
                  value={newValue}
                  onChange={this.handleChange}
                  placeholder="Enter new price"
                />
                {error && <span className="help-block">{error}</span>}
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  value={`${currUnits.currency}/${currUnits.volumeUnit}`}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div style={{padding: '10px 0'}}>
            <strong>% Difference: </strong>
            <span className={percentage.className}>
              <strong>{percentage.text}</strong>
            </span>
          </div>

          {(() => {
            // Calculate new percentage difference based on edited value
            const parsedNewValue = parseFloat(newValue);
            const parsedPrevValue = parseFloat(previousValue);
            
            if (!isNaN(parsedNewValue) && !isNaN(parsedPrevValue) && parsedPrevValue !== 0) {
              const newPercentage = ((parsedNewValue - parsedPrevValue) / parsedPrevValue) * 100;
              const newPercentageFormatted = formatPercentageChange(newPercentage);
              
              return (
                <div style={{padding: '10px 0'}}>
                  <strong>New % Difference: </strong>
                  <span className={newPercentageFormatted.className}>
                    <strong>{newPercentageFormatted.text}</strong>
                  </span>
                </div>
              );
            }
            return null;
          })()}

          <div style={{marginTop: '20px'}}>
            <Button
              bsStyle="primary"
              onClick={this.handleSave}
              disabled={isSubmitting}>
              {isSubmitting ? 'Updating...' : 'Update Price'}
            </Button>
            <span> </span>
            <Button onClick={this.props.onHide}>Cancel</Button>
          </div>
        </div>
      </DefaultModal>
    );
  }
}
